import React, { useState } from 'react'
import { useParams, useSearchParams } from 'react-router-dom';

import PageHeader from 'src/components/shared/page-header';
import TeamDetails, { type FilterType } from 'src/components/teams/details';
import StatusFilter from 'src/components/shared/status-filter';

const TeamDetailPage: React.FC = () => {
  const [filter, setFilter] = useState<FilterType>('all');
  const [searchParams,] = useSearchParams();
  const params = useParams()
  const teamName =searchParams.get('name') ?? ''

  return (
    <div className="min-h-screen w-full flex flex-col">
      <PageHeader 
        title={teamName} 
        isDetail
        rightContent={
          <StatusFilter value={filter} onChange={setFilter} />
        }
      />
      <div className="flex items-center flex-col gap-2">   
        <TeamDetails teamId={params?.teamId!} filter={filter} />
      </div>
    </div>
  )
}

export default TeamDetailPage